export default __webpack_public_path__ + "static/media/des.c7eea5f3.png";